import * as R from 'ramda';
import { connect } from 'react-redux';
import { mapProps } from 'recompose';

import SidebarHeader from '../../components/sidebar/sidebar-header';
import { getAuthorizedUser } from '../../redux/selectors';
import { modalNames, openModal } from '../../modals';

const mapStateToProps = state => ({
  authorizedUser: getAuthorizedUser(state),
});

export default R.compose(
  connect(
    mapStateToProps,
    { openModal },
  ),
  mapProps(({
    setIsOpenMobile,
    refFromWrapper,
    authorizedUser,
    collapsed,
    ...actions
  }) => ({
    setIsOpenMobile,
    onOpenManageEmails: () =>
      actions.openModal({
        name: modalNames.MANAGE_EMAILS,
      }),
    onOpenManageUsers: () =>
      actions.openModal({
        name: modalNames.MANAGE_USERS,
      }),
    onOpenOrganizationSettings: () =>
      actions.openModal({
        name: modalNames.ORGANIZATION_SETTINGS,
      }),
    collapsed,
    refFromWrapper,
    authorizedUser,
  })),
)(SidebarHeader);



// WEBPACK FOOTER //
// ./src/containers/sidebar-header/index.js